import { MESSAGE_SET, MESSAGE_REMOVE } from './types';

export const MESSAGE_TYPES = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
};

export const SET_MESSAGE_NOOP = {
  type: MESSAGE_SET,
  data: {},
};

export const setMessage = (messageObj) => {
  // Argument Validation(s)
  const { message, type } = messageObj;
  const data = {};

  // message must be a non-empty string.
  if (typeof message === 'string' && message.length) {
    data.message = message;
  } else {
    console.error('A message action requires a message given as a non-empty string.'); // eslint-disable-line no-console
    return SET_MESSAGE_NOOP;
  }

  // messageType must be one of a given set of strings.
  if (MESSAGE_TYPES[type]) {
    data.type = type;
  } else {
    console.error('A message action requires a message type as ERROR, WARNING, INFO or SUCCESS.'); // eslint-disable-line no-console
    return SET_MESSAGE_NOOP;
  }

  data.messageId = new Date().getTime();
  return {
    type: MESSAGE_SET,
    data,
  };
};

const mapErrors = (errors) => {
  const message = errors.map((error) => {
    let errorMsg = '';
    if (error.messages) {
      errorMsg = error.fieldName ? `Error in ${error.fieldName}, ${error.messages.join('\n')}.` : `${error.messages.join('\n')}.`;
    } else if (error.message) {
      errorMsg = error.message;
    } else {
      errorMsg = 'Unknown error. Please try again.';
    }
    return errorMsg;
  }).join('\n');

  return message;
};

export const setErrorMessage = (errorResponse) => {
  let message;

  if (typeof errorResponse === 'string') {
    message = errorResponse;
  } else if (typeof errorResponse === 'object' && Array.isArray(errorResponse.errors) &&
    errorResponse.errors.length > 0) {
    message = mapErrors(errorResponse.errors);
  } else if (typeof errorResponse === 'object' && Array.isArray(errorResponse.graphQLErrors) &&
    errorResponse.graphQLErrors.length > 0) {
    message = mapErrors(errorResponse.graphQLErrors);
  } else {
    message = 'Unknown error. Please try again.';
  }
  const action = setMessage({ message, type: MESSAGE_TYPES.ERROR });
  return action;
};

export const setWarningMessage = (message) => {
  const action = setMessage({ message, type: MESSAGE_TYPES.WARNING });
  return action;
};

export const setInfoMessage = (message) => {
  const action = setMessage({ message, type: MESSAGE_TYPES.INFO });
  return action;
};

export const setSuccessMessage = (message) => {
  const action = setMessage({ message, type: MESSAGE_TYPES.SUCCESS });
  return action;
};

/**
 * Remove the current message.
 */
export const removeMessage = (messageId) => {
  const data = {};

  // messageId is defined
  if (messageId && typeof messageId === 'number') {
    data.messageId = messageId;
  } else {
    console.error('messageId must be specified removing a message.'); // eslint-disable-line no-console
    return SET_MESSAGE_NOOP;
  }

  return {
    type: MESSAGE_REMOVE,
    data,
  };
};



// WEBPACK FOOTER //
// ./src/app/actions/messages/index.js